import { render, staticRenderFns } from "./ProcessInvoices.vue?vue&type=template&id=3bd245c6&"
import script from "./ProcessInvoices.vue?vue&type=script&lang=js&"
export * from "./ProcessInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports